module.exports = __webpack_public_path__ + "assets/img/b924-cl.svg";